import Sharer from 'scripts/modules/sharer';

/**
 * On DOM-ready
 */
$(() => {
    /**
     * Call a static method with the share elements/buttons
     */
    $('body').on('click', '[data-share]', function (event) {
        const options = $(this).data('share');
        const share = new Sharer(options);

        share._createPopup();

        event.preventDefault();
    });
});
